import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { SlowMo } from 'gsap/EasePack';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import Heart from '../Icons/IconHeart';

gsap.registerPlugin(SlowMo, MotionPathPlugin);
gsap.defaults({ overwrite: 'auto' });

function getRandomValue(min, max) {
  return min + (max - min) * Math.random();
}

const HeartAnimation = ({ onAnimationComplete }) => {
  const heartRef = useRef(null);
  const smallHearts = useRef([]);

  const animateStart = () => {
    const path = [];
    const newPath = [];
    const yCoordinate = -250;
    const heartWidthHeight = getRandomValue(80, 45);
    const xStep = 3;
    let cordPath = [];

    gsap.set(heartRef.current, { width: heartWidthHeight, height: heartWidthHeight });

    for (let i = 1; i < xStep; i++) {
      path.push({ x: getRandomValue(32, -96), y: i * (yCoordinate / xStep - 0.2) });
    }

    for (let a = 0; a < 5; a++) {
      for (let i = 1; i < xStep; i++) {
        cordPath.push({ x: getRandomValue(32, -96), y: i * (yCoordinate / xStep) });
      }
      newPath.push(cordPath);
      cordPath = [];
    }

    gsap.to(smallHearts.current, {
      duration: 1.4,
      opacity: 0.5,
      scale: 0,
      delay: 0.1,
      motionPath: {
        curviness: 1.5,
        path: gsap.utils.wrap(newPath),
      },
      stagger: {
        from: 'start',
        repeat: 0,
        each: 0.1,
      },
    });

    gsap.to(heartRef.current, {
      duration: 1.4,
      scale: 0.4,
      motionPath: {
        curviness: 1.3,
        path,
        autoRotate: 90,
        start: 0,
        end: 1,
      },
      onComplete() {
        onAnimationComplete();
      },
    });

    gsap.to(heartRef.current, {
      duration: 1.2,
      opacity: 1,
      ease: 'slow(0.2, 0.7, true)',
    });
  };

  useEffect(() => {
    animateStart();
  }, []);

  return (
    <div id="heartContainer">
      <div id="hearts" ref={heartRef} className="Bigheart">
        <Heart />
      </div>
      {new Array(5).fill().map((_, idx) => (
        <div
          key={`heart-indicator--${idx}`}
          ref={(div) => (smallHearts.current[idx] = div)}
          className="smallHearts"
        >
          <Heart />
        </div>
      ))}
    </div>
  );
};

export default HeartAnimation;
